export let BillingSchema = /*#__PURE__*/function (BillingSchema) {
  BillingSchema["PER_UNIT"] = "per_unit";
  BillingSchema["TIERED"] = "tiered";
  return BillingSchema;
}({});
export let TiersMode = /*#__PURE__*/function (TiersMode) {
  TiersMode["GRADUATED"] = "graduated";
  TiersMode["VOLUME"] = "volume";
  return TiersMode;
}({});